export default "__VITE_ASSET__DR1Kf$UV__"